module.exports = __webpack_public_path__ + "static/media/craft_success_first.94b6726a.mp3";